export default "__VITE_ASSET__BN_utecC__"